/**
 * @generated SignedSource<<532edb46c216f7a0c9dc24c5cd224343>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { DateTime } from "@/common/relayCustomScalar";
import { Url } from "@/common/relayCustomScalar";
export type EventScaffoldQuery$variables = {
  slug: string;
};
export type EventScaffoldQuery$data = {
  readonly eventBySlug: {
    readonly banner: Url | null | undefined;
    readonly competition: {
      readonly competition: {
        readonly slug: string;
      };
    } | null | undefined;
    readonly competitions: {
      readonly totalCount: number;
    };
    readonly createdAt: DateTime;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly isPrivate: boolean;
    readonly shortDescription: string;
    readonly slug: string;
    readonly thumbnail: Url | null | undefined;
    readonly title: string;
    readonly viewerCanAddCompetition: boolean;
    readonly viewerCanEdit: boolean;
    readonly viewerCanEditMembers: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"EventJoinButtonFragment" | "EventLocationFragment">;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  };
};
export type EventScaffoldQuery = {
  response: EventScaffoldQuery$data;
  variables: EventScaffoldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*:: as any*/)
],
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "banner",
  "storageKey": null
},
v11 = {
  "alias": "viewerCanEdit",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_EVENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_EVENT\")"
},
v12 = {
  "alias": "viewerCanEditMembers",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "ADD_EVENT_MEMBER"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"ADD_EVENT_MEMBER\")"
},
v13 = {
  "alias": "viewerCanAddCompetition",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "ADD_EVENT_COMPETITION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"ADD_EVENT_COMPETITION\")"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 0
    }
  ],
  "concreteType": "EventCompetitionConnection",
  "kind": "LinkedField",
  "name": "competitions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "competitions(first:0)"
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v1/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v2/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventCompetition",
            "kind": "LinkedField",
            "name": "competition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Competition",
                "kind": "LinkedField",
                "name": "competition",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventLocationFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventJoinButtonFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v16/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventCompetition",
            "kind": "LinkedField",
            "name": "competition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Competition",
                "kind": "LinkedField",
                "name": "competition",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Timeline",
            "kind": "LinkedField",
            "name": "timeline",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "viewerCanAgree",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "CREATE_EVENT_RULE_AGREEMENT"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"CREATE_EVENT_RULE_AGREEMENT\")"
          },
          {
            "alias": "viewerCanJoin",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "JOIN_EVENT"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"JOIN_EVENT\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventMembership",
            "kind": "LinkedField",
            "name": "membership",
            "plural": false,
            "selections": (v2/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "EventRuleAgreementConnection",
            "kind": "LinkedField",
            "name": "entityRuleAgreements",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRuleAgreement",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v2/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "entityRuleAgreements(first:1)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Forum",
            "kind": "LinkedField",
            "name": "forum",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "entitySubscription",
                "plural": false,
                "selections": (v16/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRuleAgreement",
                "kind": "LinkedField",
                "name": "entityAgreement",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aa01c34c018223a8810162a918412c84",
    "id": null,
    "metadata": {},
    "name": "EventScaffoldQuery",
    "operationKind": "query",
    "text": "query EventScaffoldQuery(\n  $slug: String!\n) {\n  viewer @ifAllowed {\n    __typename\n    id\n  }\n  eventBySlug(slug: $slug) {\n    id\n    slug\n    title\n    shortDescription\n    description\n    thumbnail\n    createdAt\n    banner\n    viewerCanEdit: viewerCan(action: UPDATE_EVENT)\n    viewerCanEditMembers: viewerCan(action: ADD_EVENT_MEMBER)\n    viewerCanAddCompetition: viewerCan(action: ADD_EVENT_COMPETITION)\n    isPrivate\n    competitions(first: 0) {\n      totalCount\n    }\n    competition {\n      competition {\n        slug\n        id\n      }\n      id\n    }\n    ...EventLocationFragment\n    ...EventJoinButtonFragment\n  }\n}\n\nfragment EventJoinButtonFragment on Event {\n  id\n  viewerCanAgree: viewerCan(action: CREATE_EVENT_RULE_AGREEMENT)\n  viewerCanJoin: viewerCan(action: JOIN_EVENT)\n  membership {\n    id\n  }\n  entityRuleAgreements(first: 1) @ifAllowed {\n    nodes {\n      id\n    }\n  }\n  forum {\n    id\n    entitySubscription @ifAllowed {\n      __typename\n      id\n    }\n  }\n  latestRule {\n    id\n    text\n    entityAgreement @ifAllowed {\n      id\n      createdAt\n    }\n  }\n}\n\nfragment EventLocationFragment on Event {\n  timeline {\n    timezone\n    startDate\n    endDate\n    locationKind\n    location {\n      country\n      city\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "816be7551217d5c539ce5aacddd9b565";

export default node;
